import { Box, Switch, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface CustomSwitchProps {
  isEnabled: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  isEnabled,
  onChange,
  label,
}) => {
  const theme = useTheme();
  const colors = theme.palette;

  const switchSx = {
    width: 34,
    height: 20,
    padding: 0,

    '& .MuiSwitch-switchBase': {
      padding: '3px',
      color: colors.toggle.thumb,

      '&.Mui-checked': {
        transform: 'translateX(14px)',
        color: colors.toggle.thumb,

        '& + .MuiSwitch-track': {
          backgroundColor: colors.toggle.trackOn,
          opacity: 1,
        },
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: colors.toggle.disabledTrack,
        opacity: 1,
      },
    },

    '& .MuiSwitch-thumb': {
      width: 14,
      height: 14,
      backgroundColor: colors.toggle.thumb,
      boxShadow: colors.toggle.thumbShadow,
    },

    '& .MuiSwitch-track': {
      borderRadius: '10px',
      backgroundColor: colors.toggle.trackOff,
      opacity: 1,
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 1,
        mb: 2,
      }}
    >
      <Switch
        sx={{
          mr: { xs: 0, sm: 1 },
          mt: { xs: 1, sm: 0 },
          ...switchSx,
        }}
        onChange={(e) => onChange(e.target.checked)}
        checked={isEnabled}
        size="small"
      />
      <Typography
        variant="tabPageHeader"
        sx={{
          color: `${colors.modal.sectionTitle} !important`,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CustomSwitch;